import { styled, Chip } from '@mui/material';

export const RouteStateChipRoot = styled(Chip)(({ theme }) => ({
  minWidth: 130,
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'uppercase',
}));
